<template>
  <div class="title_box">
    <div class="title_div">
      <img :src="titleObj.img" alt="" />
      <span class="leftName">{{ titleObj.leftName }}</span>
      <!--更多转跳-->
      <div class="rightName" v-if="titleObj.type == 0" @click="jump">
        <span>{{ titleObj.rightName }}</span>
        <img
          v-if="titleObj.needRight == 1"
          src="http://cdn.yxvzb.com/WEB/wx-master/images/pic/index_right.png"
          alt=""
        />
      </div>
      <!--显示更多-->
      <span
        v-else
        class="icon iconfont icon-unfold rightName"
        @click="openStop"
      ></span>
    </div>
    <slot name="content" v-if="show"></slot>
  </div>
</template>
<script>
/*
 * props @titleObj
 *                .img  logo
 *                .leftName title
 *                .rightName 直播预告 | 更多咨询 | 下箭头 | ....
 *                .path  转跳地址
 *                .type 0 更多事件 1 展开事件
 *
 * 默认上边距.56rem 下 .3066rem
 * */
export default {
  name: '',
  props: {
    titleObj: {
      type: Object,
      default: function() {
        return {
          img:
            'http://cdn.yxvzb.com/newWechat/image/%E9%A6%96%E9%A1%B5-%E5%8C%BB%E5%AD%A6V%E7%9B%B4%E6%92%AD@2x.png',
          leftName: '医学V视界',
          rightName: '更多直播',
          type: 1,
          path: '',
          needRight: 0
        };
      }
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    openStop() {
      this.show = !this.show;
    },
    jump() {
      let wxUserInfoObj = this.$api.getStorage('wxUserInfo');
      if (this.titleObj.path == 'headlineList') {
        sa.track(
          'BUTTON_READMORE',
          {
            eventType: 'yuedu',
            fromType: 'wx',
            client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            web_edition: 2
          },
          function() {}
        );
      } else if (this.titleObj.path == 'liveTrailer') {
        sa.track(
          'BUTTON_READMORE',
          {
            eventType: 'yugao',
            fromType: 'wx',
            client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            web_edition: 2
          },
          function() {}
        );
      }
      this.$router.push({ name: this.titleObj.path });
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.title_box {
  .title_div {
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 0.4rem;
    margin-bottom: 0.3066rem;
  }

  img {
    max-width: 0.4533rem;
    margin-right: 0.16rem;
  }
  .leftName {
    font-size: 0.4266rem;
    font-weight: bold;
  }
  .rightName {
    display: flex;
    align-items: center;
    font-size: 0.32rem;
    color: #027cfa;
    position: absolute;
    right: 0;
    img {
      margin-left: 0.15rem;
      width: 0.16rem;
    }
  }
}
</style>
